import { render, staticRenderFns } from "./DetailTop.vue?vue&type=template&id=2e8ab57c&scoped=true&"
import script from "./DetailTop.vue?vue&type=script&lang=js&"
export * from "./DetailTop.vue?vue&type=script&lang=js&"
import style0 from "./DetailTop.vue?vue&type=style&index=0&id=2e8ab57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ab57c",
  null
  
)

export default component.exports